import script from "./ChartTable.vue?vue&type=script&setup=true&lang=js"
export * from "./ChartTable.vue?vue&type=script&setup=true&lang=js"

import "./ChartTable.vue?vue&type=style&index=0&id=58356c70&scoped=true&lang=css"

import exportComponent from "C:\\Users\\user\\Desktop\\Code\\GK\\MulticaseWeb\\MulticaseWeb\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-58356c70"]])

export default __exports__